import appConfig from './app-config';

class Insights {
   private appInsights?: any;
   private isInitializing = false;

   async enableInsights(): Promise<void> {
      if (this.appInsights || this.isInitializing) return;

      this.isInitializing = true;

      try {
         const connectionString = appConfig.appInsights?.connectionString;

         // Strict validation
         if (
            !connectionString ||
            typeof connectionString !== 'string' ||
            connectionString.trim().length === 0
         ) {
            console.warn(
               'Application Insights connection string not configured. Skipping initialization.',
            );
            this.isInitializing = false;
            return;
         }

         // Lazy load the ApplicationInsights module
         const { ApplicationInsights } =
            await import('@microsoft/applicationinsights-web');

         this.appInsights = new ApplicationInsights({
            config: {
               connectionString: connectionString.trim(),
            },
         });

         this.appInsights.loadAppInsights();
         console.log('Application Insights initialized successfully');
      } catch (error) {
         console.error('App Insights initialization error:', error);
      } finally {
         this.isInitializing = false;
      }
   }
}

export default new Insights();
